var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8C9.49456 8 10.4484 7.60491 11.1517 6.90165C11.8549 6.19839 12.25 5.24456 12.25 4.25C12.25 3.25544 11.8549 2.30161 11.1517 1.59835C10.4484 0.895088 9.49456 0.5 8.5 0.5C7.50544 0.5 6.55161 0.895088 5.84835 1.59835C5.14509 2.30161 4.75 3.25544 4.75 4.25C4.75 5.24456 5.14509 6.19839 5.84835 6.90165C6.55161 7.60491 7.50544 8 8.5 8Z",
    fill: "#572148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 17.9994C2.25 17.9994 1 17.9994 1 16.0495C1 14.0996 2.25 8.25 8.5 8.25C10.1033 8.25 11.3776 8.63495 12.3861 9.24027C10.1366 9.93017 8.50098 12.0238 8.50098 14.4994C8.50098 15.829 8.97279 17.0484 9.75814 17.9994H2.25Z",
    fill: "#572148"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_430_5479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.001 9.49939C11.2397 9.49939 9.00098 11.7381 9.00098 14.4994C9.00098 17.2606 11.2397 19.4994 14.001 19.4994C16.7622 19.4994 19.001 17.2606 19.001 14.4994C19.001 11.7381 16.7622 9.49939 14.001 9.49939ZM13.376 13.8744C13.376 13.7086 13.4418 13.5497 13.559 13.4324C13.6762 13.3152 13.8352 13.2494 14.001 13.2494C14.1667 13.2494 14.3257 13.3152 14.4429 13.4324C14.5601 13.5497 14.626 13.7086 14.626 13.8744V16.9994C14.626 17.1651 14.5601 17.3241 14.4429 17.4413C14.3257 17.5585 14.1667 17.6244 14.001 17.6244C13.8352 17.6244 13.6762 17.5585 13.559 17.4413C13.4418 17.3241 13.376 17.1651 13.376 16.9994V13.8744ZM14.001 12.6344C13.9189 12.6344 13.8376 12.6182 13.7618 12.5867C13.6859 12.5553 13.617 12.5092 13.559 12.4512C13.5009 12.3931 13.4549 12.3242 13.4235 12.2483C13.3921 12.1725 13.376 12.0912 13.376 12.0091C13.376 11.927 13.3922 11.8457 13.4236 11.7699C13.4551 11.694 13.5011 11.6251 13.5592 11.5671C13.6173 11.509 13.6862 11.463 13.762 11.4316C13.8379 11.4002 13.9192 11.3841 14.0013 11.3841C14.1671 11.3841 14.3261 11.45 14.4433 11.5673C14.5605 11.6846 14.6263 11.8436 14.6263 12.0094C14.6262 12.1752 14.5603 12.3342 14.4431 12.4514C14.3258 12.5686 14.1668 12.6344 14.001 12.6344Z",
    fill: "#572148"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_430_5479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(9.00098 9.49939)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizer);
export default __webpack_public_path__ + "static/media/organizer.ea169b397c68b85fbbf51f44aee05570.svg";
export { ForwardRef as ReactComponent };